import { render, staticRenderFns } from "./Officers.vue?vue&type=template&id=b860068e"
import script from "./Officers.vue?vue&type=script&lang=js"
export * from "./Officers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports